import { get, orderBy } from "lodash";

const caseInsensitiveSort = <T extends Record<string, any>>(
  collection: T[],
  sortByField: string,
  orders?: ReadonlyArray<boolean | "asc" | "desc">
): T[] => {
  const sorted = orderBy(
    collection,
    [
      (document) => {
        const value = get(document, sortByField);
        if (typeof value === "string") {
          return value.toLowerCase();
        }
      },
    ],
    orders
  );
  return sorted;
};

export default caseInsensitiveSort;
